/* eslint-disable */
/* istanbul ignore file */
/* THIS FILE IS AUTOGENERATED - DO NOT EDIT */
import * as Types from '@shure/shared/angular/data-access/system-api/core';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type SpectrumScannerDeviceFragment = { id: string, status: Types.DeviceStatus, advertisedInterface: { model: string | null }, description: { features: { dectRfSpectrumScan: { supported: boolean }, authentication: { supported: boolean } } }, features: { name: { name: string } | null, dectRfSpectrumScan: { inProgress: boolean, results: { cumulative: { channelCounts: { highDensity: { aggressive: { max: number, min: number }, conservative: { max: number, min: number } }, standardDensity: { aggressive: { max: number, min: number }, conservative: { max: number, min: number } } }, rfAvailability: { high: number, moderate: number, low: number } }, current: { channelCounts: { highDensity: { aggressive: { max: number, min: number }, conservative: { max: number, min: number } }, standardDensity: { aggressive: { max: number, min: number }, conservative: { max: number, min: number } } }, rfAvailability: { high: number, moderate: number, low: number } } } } | null, room: { room: { id: string } | null } | null, rfBand: { band: string | null, frequencyRanges: Array<{ max: number, min: number }> | null } | null, authentication: { credentials: Array<{ credentialsState: Types.CredentialsState, accessLevel: string }> | null } | null } };

export type SpectrumScannerRoomDevicesFragment = { devices: Array<{ id: string, description: { features: { dectRfSpectrumScan: { supported: boolean } } } }> };

export type SpectrumScannerDeviceChangeFragment = { id: string, features:
    | { authentication: { credentials: Array<{ credentialsState: Types.CredentialsState, accessLevel: string }> | null } | null }
    | { dectRfSpectrumScan: { inProgress: boolean, results: { cumulative: { channelCounts: { highDensity: { conservative: { max: number, min: number }, aggressive: { max: number, min: number } }, standardDensity: { aggressive: { max: number, min: number }, conservative: { max: number, min: number } } }, rfAvailability: { high: number, low: number, moderate: number } }, current: { channelCounts: { highDensity: { conservative: { max: number, min: number }, aggressive: { max: number, min: number } }, standardDensity: { aggressive: { max: number, min: number }, conservative: { max: number, min: number } } }, rfAvailability: { high: number, low: number, moderate: number } } } } | null }
    | { name: { name: string } | null }
    | { rfBand: { band: string | null, frequencyRanges: Array<{ max: number, min: number }> | null } | null }
    | Record<PropertyKey, never>
   };

export type GetSpectrumScannerDeviceQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetSpectrumScannerDeviceQueryOpResult = { node:
    | SpectrumScannerDeviceFragment
    | Record<PropertyKey, never>
   };

export type SpectrumScannerDeviceSubscriptionVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  types: Array<Types.NodeChangeType> | Types.NodeChangeType;
}>;


export type SpectrumScannerDeviceSubscriptionOpResult = { nodeChanges:
    | SpectrumScannerDeviceFragment
    | SpectrumScannerDeviceChangeFragment
    | Record<PropertyKey, never>
   };

export type SpectrumScannerRoomDevicesSubscriptionVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  types: Array<Types.NodeChangeType> | Types.NodeChangeType;
}>;


export type SpectrumScannerRoomDevicesSubscriptionOpResult = { nodeChanges:
    | SpectrumScannerRoomDevicesFragment
    | Record<PropertyKey, never>
   };

export type StartSpectrumScannerMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type StartSpectrumScannerMutationOpResult = { startDectRfSpectrumScan: { error: { code: Types.ErrorCode, message: string } | null } };

export type StopSpectrumScannerMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type StopSpectrumScannerMutationOpResult = { stopDectRfSpectrumScan: { error: { code: Types.ErrorCode, message: string } | null } };

export type ClearSpectrumScannerMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ClearSpectrumScannerMutationOpResult = { clearDectRfSpectrumScanResults: { error: { code: Types.ErrorCode, message: string } | null } };

export type GetSpectrumScannerRoomDevicesQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetSpectrumScannerRoomDevicesQueryOpResult = { node:
    | SpectrumScannerRoomDevicesFragment
    | Record<PropertyKey, never>
   };

export const SpectrumScannerDeviceFragment = gql`
    fragment SpectrumScannerDeviceFragment on Device {
  id
  status
  advertisedInterface {
    model
  }
  description {
    features {
      dectRfSpectrumScan {
        supported
      }
      authentication {
        supported
      }
    }
  }
  features {
    name {
      name
    }
    dectRfSpectrumScan {
      inProgress
      results {
        cumulative {
          channelCounts {
            highDensity {
              aggressive {
                max
                min
              }
              conservative {
                max
                min
              }
            }
            standardDensity {
              aggressive {
                max
                min
              }
              conservative {
                max
                min
              }
            }
          }
          rfAvailability {
            high
            moderate
            low
          }
        }
        current {
          channelCounts {
            highDensity {
              aggressive {
                max
                min
              }
              conservative {
                max
                min
              }
            }
            standardDensity {
              aggressive {
                max
                min
              }
              conservative {
                max
                min
              }
            }
          }
          rfAvailability {
            high
            moderate
            low
          }
        }
      }
    }
    room {
      room {
        id
      }
    }
    rfBand {
      band
      frequencyRanges {
        max
        min
      }
    }
    authentication {
      credentials {
        credentialsState
        accessLevel
      }
    }
  }
}
    `;
export const SpectrumScannerRoomDevicesFragment = gql`
    fragment SpectrumScannerRoomDevicesFragment on Room {
  devices {
    id
    description {
      features {
        dectRfSpectrumScan {
          supported
        }
      }
    }
  }
}
    `;
export const SpectrumScannerDeviceChangeFragment = gql`
    fragment SpectrumScannerDeviceChangeFragment on DeviceChange {
  id
  features {
    ... on DeviceDectRfSpectrumScanChange {
      dectRfSpectrumScan {
        inProgress
        results {
          cumulative {
            channelCounts {
              highDensity {
                conservative {
                  max
                  min
                }
                aggressive {
                  max
                  min
                }
              }
              standardDensity {
                aggressive {
                  max
                  min
                }
                conservative {
                  max
                  min
                }
              }
            }
            rfAvailability {
              high
              low
              moderate
            }
          }
          current {
            channelCounts {
              highDensity {
                conservative {
                  max
                  min
                }
                aggressive {
                  max
                  min
                }
              }
              standardDensity {
                aggressive {
                  max
                  min
                }
                conservative {
                  max
                  min
                }
              }
            }
            rfAvailability {
              high
              low
              moderate
            }
          }
        }
      }
    }
    ... on DeviceNameChange {
      name {
        name
      }
    }
    ... on DeviceAuthenticationChange {
      authentication {
        credentials {
          credentialsState
          accessLevel
        }
      }
    }
    ... on DeviceRfBandChange {
      rfBand {
        band
        frequencyRanges {
          max
          min
        }
      }
    }
  }
}
    `;
export const GetSpectrumScannerDeviceQueryDocument = gql`
    query GetSpectrumScannerDeviceQuery($id: ID!) {
  node(id: $id) {
    ...SpectrumScannerDeviceFragment
  }
}
    ${SpectrumScannerDeviceFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSpectrumScannerDeviceQueryGQL extends Apollo.Query<GetSpectrumScannerDeviceQueryOpResult, GetSpectrumScannerDeviceQueryVariables> {
    override document = GetSpectrumScannerDeviceQueryDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SpectrumScannerDeviceSubscriptionDocument = gql`
    subscription SpectrumScannerDeviceSubscription($id: ID!, $types: [NodeChangeType!]!) {
  nodeChanges(id: $id, types: $types) {
    ...SpectrumScannerDeviceFragment
    ...SpectrumScannerDeviceChangeFragment
  }
}
    ${SpectrumScannerDeviceFragment}
${SpectrumScannerDeviceChangeFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SpectrumScannerDeviceSubscriptionGQL extends Apollo.Subscription<SpectrumScannerDeviceSubscriptionOpResult, SpectrumScannerDeviceSubscriptionVariables> {
    override document = SpectrumScannerDeviceSubscriptionDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SpectrumScannerRoomDevicesSubscriptionDocument = gql`
    subscription SpectrumScannerRoomDevicesSubscription($id: ID!, $types: [NodeChangeType!]!) {
  nodeChanges(id: $id, types: $types) {
    ...SpectrumScannerRoomDevicesFragment
  }
}
    ${SpectrumScannerRoomDevicesFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SpectrumScannerRoomDevicesSubscriptionGQL extends Apollo.Subscription<SpectrumScannerRoomDevicesSubscriptionOpResult, SpectrumScannerRoomDevicesSubscriptionVariables> {
    override document = SpectrumScannerRoomDevicesSubscriptionDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StartSpectrumScannerMutationDocument = gql`
    mutation StartSpectrumScannerMutation($id: ID!, $injectKeyring: String) {
  startDectRfSpectrumScan(id: $id, keyring: $injectKeyring) {
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StartSpectrumScannerMutationGQL extends Apollo.Mutation<StartSpectrumScannerMutationOpResult, StartSpectrumScannerMutationVariables> {
    override document = StartSpectrumScannerMutationDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StopSpectrumScannerMutationDocument = gql`
    mutation StopSpectrumScannerMutation($id: ID!, $injectKeyring: String) {
  stopDectRfSpectrumScan(id: $id, keyring: $injectKeyring) {
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StopSpectrumScannerMutationGQL extends Apollo.Mutation<StopSpectrumScannerMutationOpResult, StopSpectrumScannerMutationVariables> {
    override document = StopSpectrumScannerMutationDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ClearSpectrumScannerMutationDocument = gql`
    mutation ClearSpectrumScannerMutation($id: ID!, $injectKeyring: String) {
  clearDectRfSpectrumScanResults(id: $id, keyring: $injectKeyring) {
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ClearSpectrumScannerMutationGQL extends Apollo.Mutation<ClearSpectrumScannerMutationOpResult, ClearSpectrumScannerMutationVariables> {
    override document = ClearSpectrumScannerMutationDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSpectrumScannerRoomDevicesQueryDocument = gql`
    query GetSpectrumScannerRoomDevicesQuery($id: ID!) {
  node(id: $id) {
    ...SpectrumScannerRoomDevicesFragment
  }
}
    ${SpectrumScannerRoomDevicesFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSpectrumScannerRoomDevicesQueryGQL extends Apollo.Query<GetSpectrumScannerRoomDevicesQueryOpResult, GetSpectrumScannerRoomDevicesQueryVariables> {
    override document = GetSpectrumScannerRoomDevicesQueryDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }